import React, { useState } from 'react';
import { ShoppingCart, Menu, X, Phone, Mail, MapPin, Heart, Star, Truck, Shield, Package , Instagram} from 'lucide-react';

const EyorWebsite = () => {
  const [currentPage, setCurrentPage] = useState('home');
  const [cart, setCart] = useState([]);
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [showCart, setShowCart] = useState(false);
  const [showCheckoutForm, setShowCheckoutForm] = useState(false);
  const [currentSlide, setCurrentSlide] = useState(0);
  const [customerDetails, setCustomerDetails] = useState({
    name: '',
    phone: '',
    city: '',
    address: ''
  });
  // Slideshow images - add your product images here
const slideImages = [
  "/images/product1.jpg",
  "/images/product2.jpeg",
  "/images/product3.jpeg",
  "/images/product4.jpeg",
  "/images/product5.jpeg"
];
// Auto-advance slideshow
// Auto-advance slideshow
React.useEffect(() => {
  const timer = setInterval(() => {
    setCurrentSlide((prev) => (prev + 1) % slideImages.length);
  }, 3000); // Change slide every 3 seconds
  return () => clearInterval(timer);
}, [slideImages.length]);  // ← ADD slideImages.length here
const nextSlide = () => {
  setCurrentSlide((prev) => (prev + 1) % slideImages.length);
};

const prevSlide = () => {
  setCurrentSlide((prev) => (prev - 1 + slideImages.length) % slideImages.length);
};
  // Product data based on uploaded images - starting from ₹199
  const products = [
    {
      id: 1,
      name: "Crystal Drop Elegance",
      price: 199,
      image: "/images/product1.jpg",
      category: "Elegant",
      description: "Transparent crystal drop earrings with gold-tone accents",
      stock: 5
    },
    {
      id: 2,
      name: "Vintage Leaf Design",
      price: 249,
      image: "/images/product2.jpeg",
      category: "Vintage",
      description: "Antique silver leaf-shaped earrings with intricate detailing",
      stock: 5
    },
    {
      id: 3,
      name: "Bohemian Dreamcatcher",
      price: 299,
      image: "/images/product3.jpeg",
      category: "Bohemian",
      description: "Circular mandala design with elegant tassel drops",
      stock: 5
    },
    {
      id: 4,
      name: "Colorful Bead Hoops",
      price: 229,
      image: "/images/product4.jpeg",
      category: "Casual",
      description: "Multi-colored beaded hoop earrings with bronze finish",
      stock: 5
    },
    {
      id: 5,
      name: "Pearl Petal Drops",
      price: 279,
      image: "/images/product5.jpeg",
      category: "Elegant",
      description: "White pearl-adorned petal-shaped statement earrings",
      stock: 5
    },
    {
      id: 6,
      name: "Classic Studs Collection",
      price: 199,
      image: "/images/product6.jpeg",
      category: "Minimalist",
      description: "Variety of elegant stud earrings for everyday wear",
      stock: 5
    },
    {
      id: 7,
      name: "Golden Danglers",
      price: 259,
      image: "/images/product7.jpeg",
      category: "Traditional",
      description: "Traditional gold-tone dangling earrings",
      stock: 5
    },
    {
      id: 8,
      name: "Silver Hoops Deluxe",
      price: 239,
      image: "/images/product8.jpeg",
      category: "Contemporary",
      description: "Contemporary silver hoops with modern design",
      stock: 5
    },
    {
  id: 9,
  name: "Pearl Hoops",
  price: 269,
  image: "/images/product9.jpeg",
  category: "Elegant",
  description: "Classic pearl hoop earrings",
  stock: 4
    },
{
  id: 10,
  name: "Kundan Chandbali",
  price: 349,
  image: "/images/product10.jpeg",
  category: "Bridal",
  description: "Traditional kundan chandbali earrings",
  stock: 2
},
{
  id: 11,
  name: "Minimalist Bars",
  price: 189,
  image: "/images/product11.jpeg",
  category: "Minimalist",
  description: "Simple bar stud earrings",
  stock: 10
},
{
  id: 12,
  name: "Turquoise Drops",
  price: 229,
  image: "/images/product12.jpeg",
  category: "Bohemian",
  description: "Boho turquoise drop earrings",
  stock: 3
},
  ];

const addToCart = (product) => {
  const existing = cart.find(item => item.id === product.id);
  const currentQty = existing ? existing.quantity : 0;
  
  // Check if adding one more exceeds stock
  if (currentQty >= product.stock) {
    alert(`Sorry! Only ${product.stock} pairs available for ${product.name}`);
    return;
  }
  
  if (existing) {
    setCart(cart.map(item => 
      item.id === product.id ? {...item, quantity: item.quantity + 1} : item
    ));
  } else {
    setCart([...cart, {...product, quantity: 1}]);
  }
};

  const removeFromCart = (productId) => {
    setCart(cart.filter(item => item.id !== productId));
  };

 const updateQuantity = (productId, change) => {
  setCart(cart.map(item => {
    if (item.id === productId) {
      const product = products.find(p => p.id === productId);
      const newQty = item.quantity + change;
      
      // Check stock limit when increasing
      if (change > 0 && newQty > product.stock) {
        alert(`Sorry! Only ${product.stock} pairs available`);
        return item;
      }
      
      return newQty > 0 ? {...item, quantity: newQty} : item;
    }
    return item;
  }).filter(item => item.quantity > 0));
};

  const getTotalPrice = () => {
    return cart.reduce((total, item) => total + (item.price * item.quantity), 0);
  };

  const getTotalQuantity = () => {
  return cart.reduce((total, item) => total + item.quantity, 0);
  };

  const getProductQuantity = (productId) => {
  const item = cart.find(item => item.id === productId);
  return item ? item.quantity : 0;
};

  const validateForm = () => {
    return customerDetails.name && customerDetails.phone && customerDetails.city && customerDetails.address;
  };

 const sendWhatsAppOrder = () => {
  if (!validateForm()) {
    alert('Please fill in all your details before placing the order.');
    return;
  }

  const phoneNumber = "917836826454";
  const total = getTotalPrice();
  const shippingFee = total >= 500 ? 0 : 50;
  const finalTotal = total + shippingFee;
  
  let message = "My ORDER FROM EYOR\n\n";
  message += "Customer Details\n";
 message += `Name: ${customerDetails.name}\n`;
message += `Phone: ${customerDetails.phone}\n`;
message += `City: ${customerDetails.city}\n`;
message += `Address: ${customerDetails.address}\n\n`;

  message += "Order Details\n";
  message += "----------------\n";
  
  cart.forEach(item => {
    message += `${item.name}\n`;
message += `Qty: ${item.quantity}\n`;
message += `Price: Rs.${item.price} each\n`;
message += `Subtotal: Rs.${item.price * item.quantity}\n\n`;

  });
  
  message += "----------------\n";
  message += `Subtotal: Rs.${total}\n;`
  message += `Shipping: ${total >= 500 ? 'FREE' : 'Rs.50'}\n`
  message += `TOTAL: Rs.${finalTotal}\n\n;`
  
  if (total >= 500) {
    message += "I got FREE shipping!\n\n";
  }
  
  message += "Confirming availability and payment details. Thank you!";
  
  const encodedMessage = encodeURIComponent(message);
  const whatsappUrl = `https://wa.me/${phoneNumber}?text=${encodedMessage}`;

  
  // Use window.location instead of window.open
  window.location.href = whatsappUrl;
  
  // Reset after a small delay
  setTimeout(() => {
    setCart([]);
    setCustomerDetails({ name: '', phone: '', city: '', address: '' });
    setShowCheckoutForm(false);
    setShowCart(false);
  }, 1000);
};

  // Pages
  const HomePage = () => (
    <div className="min-h-screen">
      {/* Hero Section with Slideshow */}
<div className="relative bg-gradient-to-br from-amber-50 via-stone-50 to-neutral-100 py-20 px-4 overflow-hidden">
  {/* Background Slideshow */}
  <div className="absolute inset-0 opacity-20">
    {slideImages.map((image, index) => (
      <div
        key={index}
        className={`absolute inset-0 transition-opacity duration-1000 ${
          index === currentSlide ? 'opacity-100' : 'opacity-0'
        }`}
      >
        <img 
          src={image} 
          alt={`Slide ${index + 1}`}
          className="w-full h-full object-cover"
        />
      </div>
    ))}
  </div>

  {/* Content overlay */}
  <div className="relative max-w-6xl mx-auto">
    <div className="text-center mb-12">
      <div className="mb-8 flex justify-center">
        <div className="bg-white p-8 rounded-full shadow-lg">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 200 100" className="h-20">
            <rect fill="#faf8f3" width="200" height="100"/>
            <ellipse cx="100" cy="50" rx="80" ry="30" fill="none" stroke="#666" strokeWidth="0.5"/>
            <ellipse cx="100" cy="50" rx="60" ry="20" fill="none" stroke="#666" strokeWidth="0.5"/>
            <polygon points="95,45 97,42 99,45" fill="#666"/>
            <polygon points="105,52 107,55 109,52" fill="#666"/>
            <polygon points="85,48 87,46 89,48" fill="#666"/>
            <polygon points="115,50 117,53 119,50" fill="#666"/>
            <text x="100" y="55" fontFamily="serif" fontSize="24" textAnchor="middle" fill="#000">EYOR</text>
          </svg>
        </div>
      </div>
      <h1 className="text-5xl md:text-6xl font-serif mb-4 text-gray-800">EYOR is Yours</h1>
      <p className="text-2xl text-gray-600 mb-2">Elegance You Own & Reflect</p>
      <p className="text-lg text-gray-500 mb-8">Where elegance meets affordability</p>
      <button 
        onClick={() => setCurrentPage('shop')}
        className="bg-gray-800 text-white px-8 py-3 rounded-full hover:bg-gray-700 transition text-lg shadow-lg"
      >
        Shop Now
      </button>
    </div>

    {/* Slideshow Controls */}
    <div className="flex justify-center items-center gap-4 mt-8">
      <button 
        onClick={prevSlide}
        className="bg-white/80 hover:bg-white p-2 rounded-full shadow-lg transition"
      >
        <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
        </svg>
      </button>
      
      {/* Slide indicators */}
      <div className="flex gap-2">
        {slideImages.map((_, index) => (
          <button
            key={index}
            onClick={() => setCurrentSlide(index)}
            className={`w-3 h-3 rounded-full transition-all ${
              index === currentSlide 
                ? 'bg-gray-800 w-8' 
                : 'bg-gray-400 hover:bg-gray-600'
            }`}
          />
        ))}
      </div>

      <button 
        onClick={nextSlide}
        className="bg-white/80 hover:bg-white p-2 rounded-full shadow-lg transition"
      >
        <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
        </svg>
      </button>
    </div>
  </div>
</div>

      {/* Our Story */}
      <div className="py-16 px-4 bg-white">
        <div className="max-w-4xl mx-auto text-center">
          <h2 className="text-3xl font-serif mb-6 text-gray-800">Our Story</h2>
          <p className="text-lg text-gray-600 leading-relaxed mb-6">
            EYOR was born from a simple belief: every woman deserves to express her unique elegance. 
            We create affordable, trendy artificial jewellery that empowers you to own your style and 
            reflect your inner beauty.
          </p>
          <p className="text-lg text-gray-600 leading-relaxed">
            Each piece is thoughtfully designed to make you feel confident, sophisticated, and truly yourself. 
            When you wear EYOR, you're not just wearing jewellery—you're wearing your confidence, your elegance, 
            your story.
          </p>
        </div>
      </div>

      {/* Featured Products */}
      <div className="py-16 px-4 bg-gray-50">
        <div className="max-w-6xl mx-auto">
          <h2 className="text-3xl font-serif mb-10 text-center text-gray-800">Featured Collection</h2>
          <div className="grid grid-cols-2 md:grid-cols-3 gap-4 md:gap-8">
            {products.slice(0, 3).map(product => (
              <div key={product.id} className="bg-white rounded-lg shadow-md overflow-hidden hover:shadow-xl transition transform hover:-translate-y-1">
                <div className="h-48 md:h-64 bg-gray-100 flex items-center justify-center overflow-hidden">
                  <img src={product.image} alt={product.name} className="w-full h-full object-cover" />
                </div>
                <div className="p-3 md:p-6">
  <span className="text-xs bg-amber-100 text-amber-800 px-2 py-1 rounded-full">{product.category}</span>
  <h3 className="text-sm md:text-xl font-semibold mb-2 mt-2 md:mt-3">{product.name}</h3>
  <p className="text-gray-600 text-xs md:text-sm mb-3 md:mb-4 line-clamp-2">{product.description}</p>
  {product.stock <= 3 && (
  <p className={`text-xs font-semibold mb-2 ${
    product.stock === 0 ? 'text-red-600' : 
    product.stock === 1 ? 'text-orange-600' : 
    'text-amber-600'
  }`}>
    {product.stock === 0 ? '❌ Out of Stock' : 
     product.stock === 1 ? '⚠️ Only 1 left!' : 
     `⚠️ Only ${product.stock} left!`}
  </p>
)}
  <div className="flex justify-between items-center">
  <span className="text-base md:text-2xl font-bold text-gray-800">₹{product.price}</span>
  {getProductQuantity(product.id) === 0 ? (
    <button 
      onClick={() => addToCart(product)}
      disabled={product.stock === 0}
      className={`px-2 py-1 md:px-4 md:py-2 text-xs md:text-base rounded transition whitespace-nowrap ${
        product.stock === 0 
          ? 'bg-gray-300 text-gray-500 cursor-not-allowed'
          : 'bg-gray-800 text-white hover:bg-gray-700'
      }`}
    >
      {product.stock === 0 ? 'Sold Out' : 'Add to Cart'}
    </button>
  ) : (
    <div className="flex items-center gap-1 md:gap-2 border-2 border-amber-600 rounded-lg">
      <button 
        onClick={() => updateQuantity(product.id, -1)}
        className="w-6 h-6 md:w-8 md:h-8 bg-amber-600 text-white text-sm md:text-base font-bold rounded-l hover:bg-amber-700 transition"
      >
        −
      </button>
      <span className="w-6 md:w-10 text-center text-sm md:text-base font-semibold">
        {getProductQuantity(product.id)}
      </span>
      <button 
        onClick={() => updateQuantity(product.id, 1)}
        disabled={getProductQuantity(product.id) >= product.stock}
        className={`w-6 h-6 md:w-8 md:h-8 text-sm md:text-base font-bold rounded-r transition ${
          getProductQuantity(product.id) >= product.stock
            ? 'bg-gray-300 text-gray-500 cursor-not-allowed'
            : 'bg-amber-600 text-white hover:bg-amber-700'
        }`}
      >
        +
      </button>
    </div>
  )}
</div>
</div>
              </div>
            ))}
          </div>
          <div className="text-center mt-10">
            <button 
              onClick={() => setCurrentPage('shop')}
              className="border-2 border-gray-800 text-gray-800 px-8 py-3 rounded-full hover:bg-gray-800 hover:text-white transition"
            >
              View All Products
            </button>
          </div>
        </div>
      </div>

      {/* Why Choose EYOR */}
      <div className="py-16 px-4 bg-white">
        <div className="max-w-6xl mx-auto">
          <h2 className="text-3xl font-serif mb-10 text-center text-gray-800">Why Choose EYOR</h2>
          <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
            <div className="text-center p-6">
              <div className="w-16 h-16 bg-amber-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <Star className="w-8 h-8 text-amber-600" />
              </div>
              <h3 className="text-xl font-semibold mb-3">Premium Quality</h3>
              <p className="text-gray-600">Carefully crafted pieces that last</p>
            </div>
            <div className="text-center p-6">
              <div className="w-16 h-16 bg-amber-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <Heart className="w-8 h-8 text-amber-600" />
              </div>
              <h3 className="text-xl font-semibold mb-3">Affordable Elegance</h3>
              <p className="text-gray-600">Starting from just ₹199</p>
            </div>
            <div className="text-center p-6">
              <div className="w-16 h-16 bg-amber-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <Truck className="w-8 h-8 text-amber-600" />
              </div>
              <h3 className="text-xl font-semibold mb-3">Free Shipping</h3>
              <p className="text-gray-600">On orders over ₹500</p>
            </div>
            <div className="text-center p-6">
              <div className="w-16 h-16 bg-amber-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <Shield className="w-8 h-8 text-amber-600" />
              </div>
              <h3 className="text-xl font-semibold mb-3">7-Day Exchange</h3>
              <p className="text-gray-600">For damaged items</p>
            </div>
          </div>
        </div>
      </div>

      {/* Shipping Banner */}
      <div className="bg-gradient-to-r from-amber-600 to-amber-700 text-white py-4 px-4">
        <div className="max-w-6xl mx-auto text-center">
          <p className="text-lg font-semibold">🎉 Free Shipping on Orders Over ₹500 | 5-7 Days Delivery</p>
        </div>
      </div>
    </div>
  );

  const ShopPage = () => (
    <div className="min-h-screen py-16 px-4 bg-gray-50">
      <div className="max-w-6xl mx-auto">
        <h1 className="text-4xl font-serif mb-4 text-center text-gray-800">Our Collection</h1>
        <p className="text-center text-gray-600 mb-10">Starting from just ₹199 • Free shipping on orders over ₹500</p>
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-8">
          {products.map(product => (
            <div key={product.id} className="bg-white rounded-lg shadow-md overflow-hidden hover:shadow-xl transition transform hover:-translate-y-1">
              <div className="h-64 bg-gray-100 flex items-center justify-center relative group overflow-hidden">
                <img src={product.image} alt={product.name} className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-300" />
                <div className="absolute top-4 right-4 bg-amber-100 text-amber-800 px-3 py-1 rounded-full text-sm font-semibold">
                  {product.category}
                </div>
              </div>
              <div className="p-3 md:p-6">
                <h3 className="text-xl font-semibold mb-2">{product.name}</h3>
                <p className="text-gray-600 text-sm mb-4 line-clamp-2">{product.description}</p>
                {product.stock <= 3 && (
  <p className={`text-sm font-semibold mb-3 ${
    product.stock === 0 ? 'text-red-600' : 
    product.stock === 1 ? 'text-orange-600' : 
    'text-amber-600'
  }`}>
    {product.stock === 0 ? '❌ Out of Stock' : 
     product.stock === 1 ? '⚠️ Only 1 left!' : 
     `⚠️ Only ${product.stock} left!`}
  </p>
)}
                <div className="flex justify-between items-center">
  <span className="text-base md:text-2xl font-bold text-gray-800">₹{product.price}</span>
  {getProductQuantity(product.id) === 0 ? (
    <button 
      onClick={() => addToCart(product)}
      disabled={product.stock === 0}
      className={`px-4 py-2 rounded transition ${
        product.stock === 0 
          ? 'bg-gray-300 text-gray-500 cursor-not-allowed'
          : 'bg-gray-800 text-white hover:bg-gray-700'
      }`}
    >
      {product.stock === 0 ? 'Sold Out' : 'Add to Cart'}
    </button>
  ) : (
    <div className="flex items-center gap-2 border-2 border-amber-600 rounded-lg">
      <button 
        onClick={() => updateQuantity(product.id, -1)}
        className="w-8 h-8 bg-amber-600 text-white font-bold rounded-l hover:bg-amber-700 transition"
      >
        −
      </button>
      <span className="w-10 text-center font-semibold">{getProductQuantity(product.id)}</span>
      <button 
        onClick={() => updateQuantity(product.id, 1)}
        disabled={getProductQuantity(product.id) >= product.stock}
        className={`w-8 h-8 font-bold rounded-r transition ${
          getProductQuantity(product.id) >= product.stock
            ? 'bg-gray-300 text-gray-500 cursor-not-allowed'
            : 'bg-amber-600 text-white hover:bg-amber-700'
        }`}
      >
        +
      </button>
    </div>
  )}
</div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );

  const AboutPage = () => (
    <div className="min-h-screen py-16 px-4 bg-white">
      <div className="max-w-4xl mx-auto">
        <h1 className="text-4xl font-serif mb-8 text-center text-gray-800">About EYOR</h1>
        <div className="prose prose-lg mx-auto">
          <p className="text-lg text-gray-700 leading-relaxed mb-6">
            EYOR stands for <strong>Elegance You Own & Reflect</strong>. We believe that every woman has 
            a unique style waiting to be expressed, and jewellery is the perfect way to showcase it.
          </p>
          <h2 className="text-2xl font-serif mt-8 mb-4 text-gray-800">Our Mission</h2>
          <p className="text-gray-700 leading-relaxed mb-6">
            To make elegant, trendy artificial jewellery accessible to every woman. We carefully design 
            each piece to ensure it not only looks beautiful but also makes you feel confident and empowered.
          </p>
          <h2 className="text-2xl font-serif mt-8 mb-4 text-gray-800">Quality Promise</h2>
          <p className="text-gray-700 leading-relaxed mb-6">
            Every piece of EYOR jewellery undergoes strict quality checks. We use premium materials to 
            ensure durability and long-lasting shine, so you can wear your favorite pieces again and again.
          </p>
          
          <div className="bg-amber-50 p-6 rounded-lg my-8">
            <h2 className="text-2xl font-serif mb-4 text-gray-800">Shipping & Delivery</h2>
            <div className="space-y-3 text-gray-700">
              <p className="flex items-start">
                <Truck className="w-5 h-5 text-amber-600 mr-3 mt-1 flex-shrink-0" />
                <span><strong>Free Shipping:</strong> On all orders over ₹500</span>
              </p>
              <p className="flex items-start">
                <Package className="w-5 h-5 text-amber-600 mr-3 mt-1 flex-shrink-0" />
                <span><strong>Delivery Time:</strong> Standard delivery in 5-7 business days</span>
              </p>
              <p className="flex items-start">
                <Shield className="w-5 h-5 text-amber-600 mr-3 mt-1 flex-shrink-0" />
                <span><strong>Secure Packaging:</strong> All items carefully packed to prevent damage</span>
              </p>
            </div>
          </div>

          <div className="bg-blue-50 p-6 rounded-lg my-8">
            <h2 className="text-2xl font-serif mb-4 text-gray-800">Exchange Policy</h2>
            <p className="text-gray-700 leading-relaxed mb-3">
              We want you to love your EYOR jewellery! If you receive a damaged item, we offer a 7-day exchange policy from the date of delivery.
            </p>
            <ul className="text-gray-700 space-y-2 list-disc list-inside">
              <li>7-day exchange window for damaged items only</li>
              <li>Items must be unworn and in original packaging</li>
              <li>Contact us via WhatsApp with photos of the damaged item</li>
              <li>No refunds - exchange only policy</li>
            </ul>
          </div>

          <h2 className="text-2xl font-serif mt-8 mb-4 text-gray-800">Our Values</h2>
          <ul className="text-gray-700 space-y-2">
            <li>✨ Elegance in every design</li>
            <li>💰 Affordability without compromise - Starting from ₹199</li>
            <li>🎨 Trendy styles that evolve with you</li>
            <li>😊 Customer satisfaction above all</li>
            <li>🚚 Fast and reliable delivery</li>
            <li>🔄 Hassle-free exchanges for damaged items</li>
          </ul>
        </div>
      </div>
    </div>
  );

  const ContactPage = () => (
    <div className="min-h-screen py-16 px-4 bg-gray-50">
      <div className="max-w-4xl mx-auto">
        <h1 className="text-4xl font-serif mb-10 text-center text-gray-800">Get In Touch</h1>
        <div className="grid md:grid-cols-2 gap-8">
          <div className="bg-white p-8 rounded-lg shadow-md">
            <h2 className="text-2xl font-semibold mb-6">Contact Information</h2>
            <div className="space-y-4">
              <div className="flex items-start">
                <Phone className="w-6 h-6 text-amber-600 mr-4 mt-1 flex-shrink-0" />
                <div>
                  <p className="font-semibold">WhatsApp / Phone</p>
                  <p className="text-gray-600">+91 78368 26454</p>
                  <p className="text-sm text-gray-500 mt-1">Available for orders and queries</p>
                </div>
              </div>
              <div className="flex items-start">
                <Mail className="w-6 h-6 text-amber-600 mr-4 mt-1 flex-shrink-0" />
                <div>
                  <p className="font-semibold">Email</p>
                  <p className="text-gray-600">eyorgirls@gmail.com</p>
                </div>
              </div>
              <div className="flex items-start">
                <MapPin className="w-6 h-6 text-amber-600 mr-4 mt-1 flex-shrink-0" />
                <div>
                  <p className="font-semibold">Address</p>
                  <p className="text-gray-600">313/91D Tulsi Nagar<br/>Inderlok, Delhi, India</p>
                </div>
              </div>
            </div>
            <div className="mt-8">
              <h3 className="font-semibold mb-4">Follow Us</h3>
              <div className="flex space-x-4">
                <a href="https://in.linkedin.com/in/devita-gupta-114616271" className="w-10 h-10 bg-gradient-to-br from-purple-600 to-pink-600 rounded-full flex items-center justify-center text-white hover:opacity-80 transition">
                  <Instagram className="w-5 h-5" />
                </a>
                <span className="text-sm text-gray-500 mt-2">Coming Soon on Social Media!</span>
              </div>
            </div>
          </div>
          <div className="bg-white p-8 rounded-lg shadow-md">
            <h2 className="text-2xl font-semibold mb-6">Send Us a Message</h2>
            <p className="text-gray-600 mb-4">
              Have questions? We'd love to hear from you! Click the button below to start a conversation 
              with us on WhatsApp.
            </p>
            <button 
              onClick={() => window.open('https://wa.me/917836826454?text=Hi%20EYOR!%20I%20have%20a%20question%20about%20your%20jewellery.', '_blank')}
              className="w-full bg-green-600 text-white py-3 rounded-lg hover:bg-green-700 transition flex items-center justify-center mb-4"
            >
              <Phone className="w-5 h-5 mr-2" />
              Chat on WhatsApp
            </button>
            
            <div className="border-t pt-6 mt-6">
              <h3 className="font-semibold mb-3">Business Hours</h3>
              <p className="text-gray-600 text-sm">Monday - Saturday: 10:00 AM - 8:00 PM</p>
              <p className="text-gray-600 text-sm">Sunday: 11:00 AM - 6:00 PM</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
  
  return (
    <div className="min-h-screen bg-white">
      {/* Header */}
      <header className="bg-white shadow-sm sticky top-0 z-40">
        <div className="max-w-7xl mx-auto px-4 py-4">
          <div className="flex justify-between items-center">
            <button onClick={() => setCurrentPage('home')} className="flex items-center">
              <span className="text-2xl font-serif text-gray-800">EYOR</span>
            </button>
            
            <nav className="hidden md:flex space-x-8">
              <button onClick={() => setCurrentPage('home')} className="text-gray-700 hover:text-gray-900 transition">Home</button>
              <button onClick={() => setCurrentPage('shop')} className="text-gray-700 hover:text-gray-900 transition">Shop</button>
              <button onClick={() => setCurrentPage('about')} className="text-gray-700 hover:text-gray-900 transition">About</button>
              <button onClick={() => setCurrentPage('contact')} className="text-gray-700 hover:text-gray-900 transition">Contact</button>
            </nav>
            
            <div className="flex items-center space-x-4">
              <button 
                onClick={() => setShowCart(true)}
                className="relative hover:bg-gray-100 p-2 rounded-full transition"
              >
                <ShoppingCart className="w-6 h-6 text-gray-700" />
                {cart.length > 0 && (
                  <span className="absolute -top-1 -right-1 bg-amber-600 text-white text-xs rounded-full w-5 h-5 flex items-center justify-center font-semibold">
                    {getTotalQuantity()}
                  </span>
                )}
              </button>
              <button 
                onClick={() => setIsMenuOpen(!isMenuOpen)}
                className="md:hidden"
              >
                {isMenuOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
              </button>
            </div>
          </div>
          
          {/* Mobile Menu */}
          {isMenuOpen && (
            <nav className="md:hidden pt-4 pb-2 space-y-2 border-t mt-4">
              <button onClick={() => { setCurrentPage('home'); setIsMenuOpen(false); }} className="block w-full text-left py-2 text-gray-700 hover:bg-gray-50 px-2 rounded">Home</button>
              <button onClick={() => { setCurrentPage('shop'); setIsMenuOpen(false); }} className="block w-full text-left py-2 text-gray-700 hover:bg-gray-50 px-2 rounded">Shop</button>
              <button onClick={() => { setCurrentPage('about'); setIsMenuOpen(false); }} className="block w-full text-left py-2 text-gray-700 hover:bg-gray-50 px-2 rounded">About</button>
              <button onClick={() => { setCurrentPage('contact'); setIsMenuOpen(false); }} className="block w-full text-left py-2 text-gray-700 hover:bg-gray-50 px-2 rounded">Contact</button>
            </nav>
          )}
        </div>
      </header>

      {/* Main Content */}
      <main>
        {currentPage === 'home' && <HomePage />}
        {currentPage === 'shop' && <ShopPage />}
        {currentPage === 'about' && <AboutPage />}
        {currentPage === 'contact' && <ContactPage />}
      </main>

      {/* Footer */}
      <footer className="bg-gray-800 text-white py-12 px-4">
        <div className="max-w-6xl mx-auto">
          <div className="grid md:grid-cols-4 gap-8">
            <div>
              <h3 className="text-xl font-serif mb-4">EYOR</h3>
              <p className="text-gray-400 text-sm">Elegance You Own & Reflect</p>
              <p className="text-gray-400 text-sm mt-2">Where elegance meets affordability</p>
            </div>
            <div>
              <h4 className="font-semibold mb-4">Quick Links</h4>
              <div className="space-y-2 text-sm">
                <button onClick={() => setCurrentPage('shop')} className="block text-gray-400 hover:text-white transition">Shop</button>
                <button onClick={() => setCurrentPage('about')} className="block text-gray-400 hover:text-white transition">About Us</button>
                <button onClick={() => setCurrentPage('contact')} className="block text-gray-400 hover:text-white transition">Contact</button>
              </div>
            </div>
            <div>
              <h4 className="font-semibold mb-4">Policies</h4>
              <div className="space-y-2 text-sm text-gray-400">
                <p>Free Shipping over ₹500</p>
                <p>7-Day Exchange Policy</p>
                <p>Damaged Items Only</p>
                <p>No Refunds</p>
              </div>
            </div>
            <div>
              <h4 className="font-semibold mb-4">Contact Us</h4>
              <div className="space-y-2 text-sm text-gray-400">
                <p>📱 +91 78368 26454</p>
                <p>📱 +91 95990 30545</p>
                <p>📱 +91 78381 83471</p>
                <p>📧 eyorgirls@gmail.com</p>
                <p>📍 313/91D Tulsi Nagar</p>
                <p>Inderlok, Delhi</p>
              </div>
            </div>
          </div>
          <div className="border-t border-gray-700 mt-8 pt-8 text-center text-gray-400 text-sm">
            <p>&copy; 2025 EYOR - Elegance You Own & Reflect. All rights reserved.</p>
          </div>
        </div>
      </footer>

      {/* Cart Drawer */}
      {/* Cart Drawer */}
<div className={`fixed inset-y-0 right-0 w-full md:w-96 bg-white shadow-2xl transform transition-transform duration-300 z-50 ${
  showCart ? 'translate-x-0' : 'translate-x-full'
}`}>
  <div className="h-full flex flex-col">
    <div className="p-4 border-b flex justify-between items-center bg-gray-50">
      <h2 className="text-xl font-semibold">Shopping Cart ({getTotalQuantity()})</h2>
      <button onClick={() => { setShowCart(false); setShowCheckoutForm(false); }}>
        <X className="w-6 h-6" />
      </button>
    </div>
    
    {!showCheckoutForm ? (
      <>
        <div className="flex-1 overflow-y-auto p-4">
          {cart.length === 0 ? (
            <div className="text-center py-12">
              <ShoppingCart className="w-16 h-16 text-gray-300 mx-auto mb-4" />
              <p className="text-gray-500">Your cart is empty</p>
              <button 
                onClick={() => { setShowCart(false); setCurrentPage('shop'); }}
                className="mt-4 text-amber-600 hover:text-amber-700 font-semibold"
              >
                Start Shopping
              </button>
            </div>
          ) : (
            <div className="space-y-4">
              {cart.map(item => (
                <div key={item.id} className="border rounded-lg p-4 bg-white shadow-sm">
                  <div className="flex gap-4">
                    <img src={item.image} alt={item.name} className="w-20 h-20 object-cover rounded" />
                    <div className="flex-1">
                      <h3 className="font-semibold mb-1 text-sm">{item.name}</h3>
                      <p className="text-gray-600 text-sm mb-2">₹{item.price}</p>
                      <div className="flex items-center gap-3">
                        <button 
                          onClick={() => updateQuantity(item.id, -1)}
                          className="w-8 h-8 border rounded hover:bg-gray-100 flex items-center justify-center"
                        >
                          -
                        </button>
                        <span className="font-semibold w-8 text-center">{item.quantity}</span>
                        <button 
                          onClick={() => updateQuantity(item.id, 1)}
                          className="w-8 h-8 border rounded hover:bg-gray-100 flex items-center justify-center"
                        >
                          +
                        </button>
                        <button 
                          onClick={() => removeFromCart(item.id)}
                          className="ml-auto text-red-500 hover:text-red-700 text-sm"
                        >
                          Remove
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
        
        {cart.length > 0 && (
          <div className="border-t p-4 bg-gray-50">
            <div className="space-y-2 mb-4">
              <div className="flex justify-between text-gray-600">
                <span>Subtotal:</span>
                <span>₹{getTotalPrice()}</span>
              </div>
              <div className="flex justify-between text-gray-600">
                <span>Shipping:</span>
                <span>{getTotalPrice() >= 500 ? 'FREE ✨' : '₹50'}</span>
              </div>
              {getTotalPrice() < 500 && (
                <p className="text-xs text-amber-600">
                  Add ₹{500 - getTotalPrice()} more for FREE shipping!
                </p>
              )}
              <div className="flex justify-between text-xl font-bold pt-2 border-t">
                <span>Total:</span>
                <span>₹{getTotalPrice() + (getTotalPrice() >= 500 ? 0 : 50)}</span>
              </div>
            </div>
            <button 
              onClick={() => setShowCheckoutForm(true)}
              className="w-full bg-amber-600 text-white py-3 rounded-lg hover:bg-amber-700 transition font-semibold"
            >
              Proceed to Checkout
            </button>
          </div>
        )}
      </>
    ) : (
      <>
        <div className="flex-1 overflow-y-auto p-4">
          <div className="mb-6">
            <h3 className="text-lg font-semibold mb-4">Enter Your Details</h3>
            <p className="text-sm text-gray-600 mb-4">We need this information to process your order via WhatsApp</p>
            
            <div className="space-y-4">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Full Name *</label>
                <input
                  type="text"
                  value={customerDetails.name}
                  onChange={(e) => {
                    setCustomerDetails(prev => ({
                      ...prev,
                      name: e.target.value
                    }));
                  }}
                  className="w-full px-4 py-2 border rounded-lg focus:ring-2 focus:ring-amber-500 focus:border-amber-500"
                  placeholder="Enter your name"
                  required
                />
              </div>
              
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Phone Number *</label>
                <input
                  type="tel"
                  value={customerDetails.phone}
                  onChange={(e) => {
                    const value = e.target.value.replace(/[^0-9]/g, '');
                    if (value.length <= 10) {
                      setCustomerDetails(prev => ({
                        ...prev,
                        phone: value
                      }));
                    }
                  }}
                  className="w-full px-4 py-2 border rounded-lg focus:ring-2 focus:ring-amber-500 focus:border-amber-500"
                  placeholder="10-digit mobile number"
                  maxLength="10"
                  required
                />
              </div>
              
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">City *</label>
                <input
                  type="text"
                  value={customerDetails.city}
                  onChange={(e) => {
                    setCustomerDetails(prev => ({
                      ...prev,
                      city: e.target.value
                    }));
                  }}
                  className="w-full px-4 py-2 border rounded-lg focus:ring-2 focus:ring-amber-500 focus:border-amber-500"
                  placeholder="Your city"
                  required
                />
              </div>
              
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Delivery Address *</label>
                <textarea
                  value={customerDetails.address}
                  onChange={(e) => {
                    setCustomerDetails(prev => ({
                      ...prev,
                      address: e.target.value
                    }));
                  }}
                  rows="3"
                  className="w-full px-4 py-2 border rounded-lg focus:ring-2 focus:ring-amber-500 focus:border-amber-500"
                  placeholder="House no., Street, Locality"
                  required
                ></textarea>
              </div>
            </div>
            
            <div className="mt-6 p-4 bg-blue-50 rounded-lg">
              <h4 className="font-semibold mb-2 text-sm">Order Summary</h4>
              <div className="space-y-1 text-sm text-gray-600">
                {cart.map(item => (
                  <div key={item.id} className="flex justify-between">
                    <span>{item.name} x{item.quantity}</span>
                    <span>₹{item.price * item.quantity}</span>
                  </div>
                ))}
                <div className="border-t pt-1 mt-2 font-semibold text-gray-800">
                  <div className="flex justify-between">
                    <span>Total:</span>
                    <span>₹{getTotalPrice() + (getTotalPrice() >= 500 ? 0 : 50)}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        
        <div className="border-t p-4 bg-gray-50 space-y-3">
          <button 
            onClick={sendWhatsAppOrder}
            disabled={!validateForm()}
            className={`w-full py-3 rounded-lg transition font-semibold flex items-center justify-center ${
              validateForm() 
                ? 'bg-green-600 text-white hover:bg-green-700' 
                : 'bg-gray-300 text-gray-500 cursor-not-allowed'
            }`}
          >
            <Phone className="w-5 h-5 mr-2" />
            Place Order via WhatsApp
          </button>
          <button 
            onClick={() => setShowCheckoutForm(false)}
            className="w-full py-2 text-gray-600 hover:text-gray-800"
          >
            ← Back to Cart
          </button>
          <p className="text-xs text-gray-500 text-center">
            You'll be redirected to WhatsApp to complete your order
          </p>
        </div>
      </>
    )}
  </div>
</div>
      {/* Overlay */}
      {showCart && (
        <div 
          className="fixed inset-0 bg-black bg-opacity-50 z-40"
          onClick={() => { setShowCart(false); setShowCheckoutForm(false); }}
        ></div>
      )}
    </div>
  );
};

export default EyorWebsite;